import {NotificationCountLimit} from '@toolify/server/src/services/NotificationService/constants/NotificationCountLimit'

export const NotificationBadgeMax = NotificationCountLimit - 1
